/**
 * Device detection utilities for camera barcode scanning
 */

/**
 * Check if device has camera capability
 * @returns {boolean}
 */
export const hasCamera = () => {
  const isSecureContext = window.isSecureContext
  const hasGetUserMedia = !!(
    navigator.mediaDevices && navigator.mediaDevices.getUserMedia
  )

  // iOS requires HTTPS for camera access (except localhost)
  if (!isSecureContext && /iPhone|iPad|iPod/.test(navigator.userAgent)) {
    console.warn(
      'Camera not available: iOS requires HTTPS for camera access (current protocol: ' +
        window.location.protocol +
        ')',
    )
    return false
  }

  return hasGetUserMedia
}

/**
 * Check if device is a mobile phone
 * @returns {boolean}
 */
export const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const hasTouchScreen =
    'ontouchstart' in window || navigator.maxTouchPoints > 0
  const isMobileUA =
    /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent.toLowerCase(),
    )

  return hasTouchScreen && isMobileUA
}

/**
 * Check if device is a tablet
 * @returns {boolean}
 */
export const isTabletDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  // Check for iPad
  const isIPad =
    /ipad/i.test(userAgent.toLowerCase()) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

  // Check for Android tablet
  const isAndroidTablet =
    /android/i.test(userAgent.toLowerCase()) &&
    !/mobile/i.test(userAgent.toLowerCase())

  return isIPad || isAndroidTablet
}

/**
 * Get camera device type
 * @returns {'mobile'|'tablet'|'desktop'|'none'}
 */
export const getCameraDeviceType = () => {
  if (isMobileDevice()) return 'mobile'
  if (isTabletDevice()) return 'tablet'
  if (hasCamera()) return 'desktop'
  return 'none'
}

/**
 * Check if device is desktop (non-mobile and non-tablet)
 * @returns {boolean}
 */
export const isDesktop = () => {
  return !isMobileDevice() && !isTabletDevice()
}
